import { useApi } from "../api";
import { createAdminCrudApi } from "../createAdminCrudApi";
import { DECK_ADMIN_URL } from "./deckAdminUrl";
import { InsertConnectorBody, SearchConnectorsResponse, UpdateConnectorBody } from "./types/connectors";

export const useDeckConnectorsApi = () => {
  const crud = createAdminCrudApi<SearchConnectorsResponse, InsertConnectorBody, UpdateConnectorBody>(
    useApi(),
    DECK_ADMIN_URL,
    "connectors",
  );

  return {
    useDeckConnectors: crud.useSearch,
    insertDeckConnector: crud.insert,
    updateDeckConnector: crud.update,
    deleteDeckConnector: crud.remove,
    updateDeckConnectorVisibility: crud.updateVisibility,
    updateDeckConnectorOrder: crud.updateOrder,
  };
};

export default useDeckConnectorsApi;
